import { render, staticRenderFns } from "./CustomerLocation.vue?vue&type=template&id=5e5f1d3b&scoped=true"
import script from "./CustomerLocation.vue?vue&type=script&lang=js"
export * from "./CustomerLocation.vue?vue&type=script&lang=js"
import style0 from "./CustomerLocation.vue?vue&type=style&index=0&id=5e5f1d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5f1d3b",
  null
  
)

export default component.exports